/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiUrl: 'https://extranet.baic.tech/api',
  // apiUrl: 'https://localhost:5001/api',
  // tslint:disable-next-line: max-line-length
  extensions: '.pdf,' + // PDF
              '.psd,.ps,.ai,' + // Adobe files
              '.csv,' + // CSV
              '.txt,.rtf,' + // Text files
              '.rar,.zip,.7z,' + // Zipped files
              '.xlc,.xls,.xlsx,.xlsm,.xlsb,.xltx,.xltm,.xlt,.xla,.xlw,.xlam,' + // Excel files
              '.docx,.docm,.dotx,.dotm,.doc,.wps,.dot,' + // Word files
              '.pot,.potm,.potx,.ppa,.ppam,.pps,.ppsm,.ppsx,.ppt,.pptm,.pptx,' + // Power point files
              '.jpg,.gif,.jpeg,.png,.bmp,' + // Images files
              '.mp4,.avi,.wmv,.mov,' + // Video files
              '.mp3,.wav,' + // Audio files
              '.xml,.cut,.pages', // CUT (unknown in tree's icon)
  testUser: {
    // tslint:disable
    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjIiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiQFVzZXIiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL2FjY2Vzc2NvbnRyb2xzZXJ2aWNlLzIwMTAvMDcvY2xhaW1zL2lkZW50aXR5cHJvdmlkZXIiOiJBU1AuTkVUIElkZW50aXR5IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoidXNlciIsIm5iZiI6MTU1MDA2NDE3NCwiZXhwIjoxNTgxNjg2NTc0LCJpc3MiOiJpc3N1ZXJfc2FtcGxlIiwiYXVkIjoiYXVkaWVuY2Vfc2FtcGxlIn0.ctOTvAv-RK_IhFx0nFzOKQ1R19fenVf6UyLR_Mq8j2c',
    // tslint:enable
    email: 'user@user.user',
  },
};
